import { baseUrl } from "../config";

export const MOLONI_BASE_PATH = `${baseUrl}/moloni`;

